module.exports = __webpack_public_path__ + "img/fus-icon.179a3bfd.jpg";